export const GET_CONFIG = 'GET_CONFIG';
export const EDIT_CONFIG = 'EDIT_CONFIG';

export const GET_PAYMENT_METHODS = 'GET_PAYMENT_METHODS';
export const EDIT_PAYMENT_METHOD = 'EDIT_PAYMENT_METHODS';
export const DELETE_PAYMENT_METHODS = 'DELETE_PAYMENT_METHODS';
export const CREATE_PAYMENT_METHOD = 'CREATE_PAYMENT_METHOD';
export const DELETE_CERT = 'DELETE_CERT'
export const UPLOAD_CERT = 'UPLOAD_CERT'